module.exports = __webpack_public_path__ + "img/aticket.8d62c72e.png";